
export default {
  props: {
    selectedVariant: { type: Object, required: true },
    product: { type: Object, required: true },
    storeContent: { type: Array, required: true },
  },

  data: () => ({ deliveryTab: true }),
};
